import React from "react"
import type { CMSPageProps } from "packages/acquisition/components/chakra-components/LandingPage/LandingPage.utils"
import { ElementViewEventWrapper } from "packages/acquisition/components/chakra-components/LandingPage/ElementViewEventWrapper"
import { useScreenViewport } from "lib/checkViewport"
import {
  container,
  titleContainer,
  title as titleClass,
  membershipCardsContainer,
} from "./MembershipOptions.css"
import type { LandingPageMembershipOptions } from "./MembershipOption/MembershipOption"
import { MembershipOption } from "./MembershipOption/MembershipOption"

type Props = CMSPageProps & {
  backgroundColor: string
  membershipCards: LandingPageMembershipOptions[]
  title: string
}

export const MembershipOptions: React.FC<Props> = ({
  title,
  backgroundColor,
  membershipCards,
  trackingModule,
}) => {
  const { isMobile, isTablet } = useScreenViewport()

  const childHasRibbon = membershipCards.some((card) => card.ribbonContent)

  const membershipCardsSkus = membershipCards
    .map((card) => card.sku)
    .toString()
    .split(",")
    .join(" | ")

  const { modulePosition } = trackingModule
  return (
    <ElementViewEventWrapper
      trackingModule={{
        ...trackingModule,
        moduleContentDetails: membershipCardsSkus,
      }}
      disabled={isMobile}
    >
      <div className={container} style={{ backgroundColor }}>
        <div className={titleContainer}>
          {modulePosition === 1 ? (
            <h1 className={titleClass}>{title}</h1>
          ) : (
            <h2 className={titleClass}>{title}</h2>
          )}
        </div>
        <div
          className={membershipCardsContainer}
          style={{
            marginTop: childHasRibbon && !isTablet && !isMobile ? "6.25rem" : 0,
          }}
        >
          {membershipCards?.map((card, i) => (
            <MembershipOption
              key={card.sku}
              trackingModule={trackingModule}
              disable={i === 0}
              {...card}
            />
          ))}
        </div>
      </div>
    </ElementViewEventWrapper>
  )
}
